// contactTypeLabel.ts — Anzeigename des Kontakttyps.
//
// Der Typ heißt in der Datenbank „Person", in der Oberfläche aber „Privat" — so
// nennen ihn die Kollegen, und so steht er im Anlage-Menü. Die Umbenennung ist
// REIN SPRACHLICH: der Rohwert geht unverändert an die API, steckt in den
// persistierten Filterzuständen und in den Convert-URLs (`/contacts/:id/convert/
// Person`). Wer statt des Labels den Wert ersetzt, bricht Filter und Navigation.
//
// ⚠️ Nicht gemeint sind „Ansprechpartner", „Personen im Unternehmen" o. ä. —
// das sind andere Begriffe und bleiben, wie sie sind.

/** Gespeicherter Kontakttyp — so kennen ihn API, Filter und Routen. */
export const KONTAKTTYP_PERSON = "Person";

/** Anzeigename desselben Typs. */
export const KONTAKTTYP_PERSON_LABEL = "Privat";

/**
 * Rohwert → Anzeigetext. Alles außer „Person" bleibt unverändert, damit die
 * Funktion auch dort durchgereicht werden kann, wo der Typ leer oder numerisch
 * ist (`ContactDetailsFormValues.typ` ist `string | number`).
 */
export const contactTypeLabel = <T extends string | number | boolean | null | undefined>(
  typ: T,
): T | string => (typ === KONTAKTTYP_PERSON ? KONTAKTTYP_PERSON_LABEL : typ);

/**
 * Anzeigetext → Rohwert. Gegenrichtung für Filter, die mit dem Label arbeiten;
 * der Wert, der ans Backend geht, heißt weiterhin „Person".
 */
export const contactTypeValue = <T extends string | boolean | null | undefined>(
  label: T,
): T | string => (label === KONTAKTTYP_PERSON_LABEL ? KONTAKTTYP_PERSON : label);
